import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { ApplicationSecurityService } from '../services/application-security.service';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class ApplicationSecurityLogsComponent implements OnInit {
  constructor(
    private location: Location,
    private applicationSecuritySvc: ApplicationSecurityService
  ) {}
  filter = new AppFilter({ _search: false, sidx: 'dateRequested' });
  totalItems = 0;
  rows = 10;
  maxSize = 10;
  currentPage = 1;
  pending: boolean;
  success;
  error;
  logs;

  getPage(pageNumber: number) {}

  nextPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getRequestsLog();
  }

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'ipAddress',
        op: 'cn',
        data: '',
      },
      {
        field: 'requestMethod',
        op: 'cn',
        data: '',
      },
      {
        field: 'responseStatusCode',
        op: 'cn',
        data: '',
      },
      {
        field: 'requestPath',
        op: 'cn',
        data: '',
      },
    ],
  };

  headerFilters = [
    {
      field: 'requestMethod',
      label: 'Request Method',
      type: 'select',
      op: 'eq',
      choices: [
        {
          optionId: 'GET',
          optionName: 'GET',
        },
        {
          optionId: 'PUT',
          optionName: 'PUT',
        },
        {
          optionId: 'POST',
          optionName: 'POST',
        },
        {
          optionId: 'DELETE',
          optionName: 'DELETE',
        },
        {
          optionId: 'OPTIONS',
          optionName: 'OPTIONS',
        },
      ],
      data: '',
    },
    {
      field: 'responseStatusCode',
      label: 'Response Status Code',
      type: 'select',
      op: 'eq',
      choices: [
        {
          optionId: '200',
          optionName: '200',
        },
        {
          optionId: '500',
          optionName: '500',
        },
        {
          optionId: '404',
          optionName: '404',
        },
        {
          optionId: '429',
          optionName: '429',
        },
        {
          optionId: '403',
          optionName: '403',
        },
        {
          optionId: '401',
          optionName: '401',
        },
        {
          optionId: '400',
          optionName: '400',
        },
        {
          optionId: '504',
          optionName: '504',
        },
      ],
      data: '',
    },
  ];
  headers = [
    {
      field: 'responseStatusCode',
      label: 'Status Code',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'requestMethod',
      label: 'Request Method',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'ipAddress',
      label: 'IP Address',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'requestPath',
      label: 'Request URL',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  searchRecords(event) {
    this.searchFilter.rules[0].data = event;
    this.searchFilter.rules[1].data = event;
    this.searchFilter.rules[2].data = event;
    this.searchFilter.rules[3].data = event;
    this.filter._search = true;

    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = 1;
    this.getRequestsLog();
  }

  displayRecords(row) {
    this.filter['rows'] = row;
    this.currentPage = 1;
    this.getRequestsLog();
  }

  goBack() {
    this.location.back();
  }

  getRequestsLog() {
    this.pending = true;
    this.applicationSecuritySvc
      .getRequestLogs({ param: this.filter })
      .subscribe(
        (res: any) => {
          console.log(res);
          this.totalItems = +res.records;
          this.currentPage = +res.page;
          this.logs = res.rows;
          this.rows = this.filter.rows;
          this.pending = false;
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;

          this.pending = false;
        }
      );
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.page = 1;
    this.getRequestsLog();
  }

  advancedSearch(search) {
    search.rules = search.rules.filter(
      (rule) =>
        (rule.field === 'requestMethod' && rule.data) ||
        (rule.field === 'responseStatusCode' && rule.data)
    );
    console.log(search);
    if (search) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;
    this.getRequestsLog();
  }

  ngOnInit(): void {
    this.getRequestsLog();
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });
    this.getRequestsLog();
  }

  reload() {
    this.filter.page = 1;
    this.getRequestsLog();
  }

  onSuccess(event) {
    this.success = event;
  }
}
